import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

// material
import { styled } from '@mui/material/styles';
//
import { useDispatch, useSelector } from 'react-redux';
import { restoreUserSession } from '../../store/actions/auth';
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';
import FullOverlayLoader from '../../components/FullOverlayLoader';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
// Floating navbar: 72px height + 16px top margin + 24px gap below
const APP_BAR_DESKTOP = 72 + 16 + 24;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
  backgroundColor: 'transparent',
});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  // Mobile: top bar height + gap; bottom: room for mobile bottom nav bar
  paddingTop: APP_BAR_MOBILE + 16,
  paddingBottom: 72, // height of mobile bottom nav
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP,
    paddingBottom: theme.spacing(6),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  const path = useLocation().pathname;
  const dispatch = useDispatch();
  const { isAuthenticated, isLoading } = useSelector((state) => state.auth);

  // Restore user session on mount
  useEffect(() => {
    dispatch(restoreUserSession());
  }, [dispatch]);

  if (isLoading || !isAuthenticated) {
    return <FullOverlayLoader />;
  }

  return (
    <RootStyle>
      <DashboardSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
      <MainStyle>
        <DashboardNavbar onOpenSidebar={() => setOpen(true)} />
        <Outlet />
      </MainStyle>
    </RootStyle>
  );
}
